import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  size?: number;
  fill?: string;
};

export const TelegramIcon = ({ size = 8, fill = '#ECECEC' }: Props) => (
  <chakra.svg
    xmlns="http://www.w3.org/2000/svg" 
    width={`${18 / 32 * size * 4}px`} 
    height={`${14 / 32 * size * 4}px`} 
    viewBox="0 0 18 14" 
    fill="none"
  >
    <path 
      d="M16.5908 0.0881948L0.830761 5.55129C-0.244794 5.93963 -0.238572 6.47899 0.633428 6.7195L4.67965 7.85415L14.0414 2.54447C14.4841 2.30236 14.8885 2.4326 14.5561 2.69789L6.97121 8.85136H6.96943L6.97121 8.85216L6.6921 12.6013C7.10098 12.6013 7.28143 12.4327 7.51076 12.2337L9.47609 10.5158L13.5641 13.2301C14.3179 13.6033 14.8592 13.4115 15.0468 12.6029L17.7303 1.23403C18.005 0.244009 17.3099 -0.204257 16.5908 0.0881948Z" 
      fill={fill}
    />
  </chakra.svg>
);
